import { c as _c } from "react/compiler-runtime";
import { CreditDirection } from "../GroupCard";
export default function GroupCardActionCreditDirection(t0) {
  const $ = _c(16);
  const {
    creditDirection,
    setCreditDirection
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [CreditDirection.ADD]: "tw-border-green tw-text-green",
      [CreditDirection.SUBTRACT]: "tw-border-red tw-text-red"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const activeClasses = t1;
  let t2;
  if ($[1] !== setCreditDirection) {
    t2 = () => setCreditDirection(CreditDirection.SUBTRACT);
    $[1] = setCreditDirection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${creditDirection === CreditDirection.SUBTRACT ? activeClasses[CreditDirection.SUBTRACT] : "hover:tw-bg-iron-800 tw-border-iron-650 tw-text-iron-400"} tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-lg tw-bg-iron-900 
          tw-w-8 tw-h-8 tw-text-base tw-font-semibold  tw-shadow-sm hover:tw-bg-iron-800 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-transition tw-duration-300 tw-ease-out`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-size-4 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3) {
    t5 = <button onClick={t2} type="button" title="Subtract" className={t3}>{t4}</button>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== setCreditDirection) {
    t6 = () => setCreditDirection(CreditDirection.ADD);
    $[7] = setCreditDirection;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `${creditDirection === CreditDirection.ADD ? activeClasses[CreditDirection.ADD] : "hover:tw-bg-iron-800 tw-border-iron-650 tw-text-iron-400"} tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-lg tw-bg-iron-900 
          tw-w-8 tw-h-8 tw-text-base tw-font-semibold  tw-shadow-sm hover:tw-bg-iron-800 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-transition tw-duration-300 tw-ease-out`;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-size-4 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t7) {
    t9 = <button onClick={t6} type="button" title="Add" className={t7}>{t8}</button>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t9) {
    t10 = <div className="tw-flex tw-gap-x-2">{t5}{t9}</div>;
    $[13] = t5;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}